(async () => {
    const { Core } = await importModule('Core');
    const { Routes, parseHTML, $replaceContent } = await importModule('Utils');

    const CART_R_SECTION = 'r_cart';
    const NOTIFICATION_SECTION = 'r_cart-notification';
    const ATTR_IS_CART_PAGE = 'cart-page';
    const SECTION_DRAWER = 'g_cart-drawer';

    customElements.define('cart-provider', class extends Core {
        subscriptions = {
            'cart:add-feature': '_addFeature',
            'cart:add': '_add',
            'cart:change': '_update'
        }

        features = {};

        render() {
            this.subscribe('cart:add-feature', { global: true });
            this.subscribe('cart:add', { global: true });
            this.subscribe('cart:change', { global: true });
        }

        _addFeature({ feature }) {
            this.features[feature] = true;
        }

        async _add({ items }) {
            try {
                const resBody = { items };
                if (this.features['notification']) {
                    resBody.sections = [NOTIFICATION_SECTION];
                    resBody.attributes = {
                        notification_items_variant_ids: items.map(({ id }) => id).join(',')
                    };
                }
                const res = await this._requestCart('cartAdd', resBody);
                this._cleanCartAttributes();

                if (this.redirectToCart) {
                    window.location.pathname = Routes('cart');
                    return;
                }

                const cartData = await res.json();
                if (!res.ok) {
                    throw new Error(JSON.stringify({ message: cartData.message, description: cartData.description }));
                } else {
                    this._publishUpdates(cartData);
                }
            } catch (e) {
                console.error("[Add Items] Error adding items to cart:", e);
                const { message = '', description = '' } = JSON.parse(e.message);
                if (message || description) {
                    this.publish('toast-notification:open', { title: message, message: description, type: 'error' });
                }
                this.publish('cart:error');
            }
        }

        _cleanCartAttributes() {
            if (this.features['notification']) {
                this._requestCart('cartUpdate', { attributes: { notification_items_variant_ids: null } });
            }
        }

        async _update(eventDetail) {
            console.log("[Update Cart] Event Detail Received:", eventDetail);

            let { updates } = eventDetail;

            if (!Array.isArray(updates)) {
                console.warn("[Update Cart] Invalid updates format, expected an array:", updates);
                return;
            }

            console.log("[Update Cart] Initial Updates Array:", updates);

            updates = await window.calculateAndAdjustQuantities(updates);

            if (!updates || updates.length === 0) {
                console.error("[Update Cart] Failed to adjust secondary product quantities. Aborting update.");
                return;
            }

            console.log("[Update Cart] Adjusted Updates Array:", updates);

            try {
                for (const update of updates) {
                    console.log("[Update Cart] Processing Update:", update);

                    if (!update.key || typeof update.quantity !== 'string') {
                        console.error("[Update Cart] Invalid Update Detected:", update);
                        continue;
                    }

                    console.log(`[Update Cart] Sending Request for Update: Key=${update.key}, Quantity=${update.quantity}`);

                    const { key, quantity, selling_plan } = update;
                    const body = {
                        id: key,
                        quantity,
                        selling_plan,
                        sections: [CART_R_SECTION],
                        sections_url: Routes('cart')
                    };

                    const res = await this._requestCart('cartChange', body);

                    const cartData = await res.json();
                    if (!res.ok) {
                        console.error(`[Update Cart] Error During Cart Change Request for Key=${key}:`, cartData);
                        continue;
                    }

                    console.log("[Update Cart] Successful Cart Change for Key:", key);
                    this._publishUpdates(cartData);
                }
            } catch (e) {
                console.error("[Update Cart] Error during cart change request:", e);
            }
        }

        async _publishUpdates(cartData) {
            const eventData = {};

            if (this.features['cart-total'] || this.features['counter'] || this.features['drawer'] || this.features['cart']) {
                eventData.meta = await this._getCartMeta();
            }

            if (this.features['drawer']) {
                eventData.drawer = {
                    section: await this._getDrawerSection(),
                    open: !this.features['notification']
                };
            }

            if (this.features['notification'] && cartData.sections && cartData.sections[NOTIFICATION_SECTION]) {
                eventData.notification = {
                    section: cartData.sections[NOTIFICATION_SECTION],
                    recommendationProductId: cartData.items[0]?.product_id
                };
            }

            if (this.features['cart'] && cartData.sections && cartData.sections[CART_R_SECTION]) {
                const $cartDoc = parseHTML(cartData.sections[CART_R_SECTION]);
                eventData.cart = {
                    getCount: () => $cartDoc.querySelector('[data-cart-counter]').innerText,
                    getItems: () => $cartDoc.querySelector('[data-cart-items]'),
                    getSubtotalBlock: () => $cartDoc.querySelector('[data-cart-subtotal-block]'),
                    getFreeShippingBlock: () => $cartDoc.querySelector('[data-cart-free-shipping-block]')
                };
            }

            this.publish('cart:update', eventData);
        }

        async _getCartMeta() {
            const res = await fetch(`${Routes('cart')}?view=meta`);
            const { count, ...data } = await res.json();
            return { count: Number(count), ...data };
        }

        async _getDrawerSection() {
            const res = await fetch(`${Routes('root')}?section_id=${SECTION_DRAWER}`);
            const sectionText = await res.text();
            return sectionText;
        }

        _requestCart(route, body) {
            return fetch(`${Routes(route)}.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(body)
            });
        }

        get isCartPage() {
            return this.hasAttribute(ATTR_IS_CART_PAGE);
        }

        get redirectToCart() {
            return !this.isCartPage && !this.features['notification'] && !this.features['drawer'];
        }
    });
})();
